<template>
  <div
    @click="handleClick"
    @keyup.enter="handleClick"
    class="rotator-slide__wrapper"
    role="button"
    tabindex="0"
  >
    <div class="rotator-slide">
      <v-responsive class="rotator-slide__top" :aspect-ratio="aspectRatio">
        <div class="speaker-avatar">
          <img :src="data.preview_urls.thumb" alt="avatar" />
        </div>
      </v-responsive>
      <div class="rotator-slide__bottom">
        <div class="speaker-name">
          {{ data.name }}
        </div>
        <div class="speaker-title" v-html="data.title_html" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Speaker",
  props: {
    data: Object
  },
  methods: {
    handleClick() {
      this.$emit("click", this.data);
    }
  },
  computed: {
    aspectRatio() {
      const aspectRatio = {
        lg: 287 / 160,
        sm: 394 / 350,
        xs: 394 / 350
      };

      return aspectRatio[this.$size] || 287 / 160;
    }
  }
};
</script>

<style scoped lang="scss">
@import "@/styles/variables.scss";

.rotator-slide__wrapper {
  overflow: visible;
  padding: 4px;
}
.rotator-slide {
  &__top {
    background: url(~@/assets/ripple_speaker.png);
    background-size: cover;
    background-position: center;
    border-radius: 13px;
    display: flex;
    justify-content: center;
    align-items: center;

    .speaker-avatar {
      display: flex;
      align-items: center;
      justify-content: center;

      img {
        border: 4px solid $stjude-red;
        border-radius: 50%;
        filter: drop-shadow(0px 2px 5px rgba(0, 0, 0, 0.25));
        object-position: top center;
        object-fit: cover;
        width: 96px;
        height: 96px;
      }
    }
  }

  &__bottom {
    margin-top: 12px;
    min-height: 75px;

    .speaker-name {
      font-weight: 800;
      font-size: 18px;
      line-height: 24px;
      color: $stjude-red;
    }
    .speaker-title {
      margin: 5px 0 2px;
      font-size: 14px;
      line-height: 16px;
    }
    .speaker-day {
      font-weight: 800;
      font-size: 14px;
      line-height: 16px;
    }
  }
}

@media screen and (max-width: 960px) {
  .rotator-slide__wrapper {
    padding: 20px 0;
  }
}
</style>
